import globals from '../../globlas';
import { _sendWithAxios, _sendWithAxiosBlob } from '../api';

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API;

export const autenticarUsuario = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}AutenticarUsuario/login`, 'POST',data)
}